import React from 'react';
import '../../estilos/BarraAccionesSeleccion.css';

/**
 * Barra de acciones flotante que aparece cuando hay elementos seleccionados
 * Similar al estilo de Gmail
 */
const BarraAccionesSeleccion = ({ 
  cantidadSeleccionados, 
  tipo, // 'subcontratos' o 'materiales'
  onEliminar, 
  onCancelar,
  eliminando 
}) => {
  if (cantidadSeleccionados === 0) return null;

  const tipoTexto = tipo === 'subcontratos' ? 'subcontrato' : 'material';
  const tipoPlural = cantidadSeleccionados === 1 ? tipoTexto : `${tipoTexto}es`;

  return (
    <div className="barra-acciones-seleccion">
      <div className="barra-acciones-contenido">
        <span className="barra-acciones-contador">
          <strong>{cantidadSeleccionados}</strong> {tipoPlural} seleccionado{cantidadSeleccionados !== 1 ? 's' : ''}
        </span>
        
        <div className="barra-acciones-botones">
          <button 
            className="barra-btn-eliminar"
            onClick={onEliminar}
            disabled={eliminando}
          >
            {eliminando ? (
              <>
                <span className="spinner-small"></span>
                Eliminando...
              </>
            ) : (
              <>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                  <path fillRule="evenodd" d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.519.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z" clipRule="evenodd" />
                </svg>
                Eliminar seleccionados
              </>
            )}
          </button>
          
          <button 
            className="barra-btn-cancelar"
            onClick={onCancelar}
            disabled={eliminando}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
            </svg>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default BarraAccionesSeleccion;
